import { render, staticRenderFns } from "./CompGrid3x1.vue?vue&type=template&id=e95b2ea2"
import script from "./CompGrid3x1.vue?vue&type=script&lang=js"
export * from "./CompGrid3x1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports